module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-sub-section"
  }, [_c('div', {
    staticClass: "rt-sub-section-header"
  }, [_c('p', {
    staticClass: "rt-sub-section-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
    staticClass: "rt-sub-section-body"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50dac29e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/section/rtSubSection.vue
// module id = 1497
// module chunks = 72